import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { DashboardPageComponent } from "app_dashboard/pages/dashboard/dashboard-page.component";

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                pathMatch: 'full',
                component: DashboardPageComponent,
            },
        ])
    ],
    exports: [
        RouterModule,
    ]
})
export class DashboardPageRouting {
}
